module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAV1BMVEUAAABIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVxIUVyOsaF2AAAAHHRSTlMABeWmoZZ/4KpGOPbo1reakoh8cm492diueFoRemJUdAAAAHpJREFUGNNdjEkSg0AMA8eeHQIBAln1/3cGDyoO6CCVuyS7XZtXqO8cJRE5LlExyQHuSGI8YWp3h8RqQlsVFQJRb3GLu3Gs5ljMubk0Ymu88/kjF4uKB8EHW8tAsuIpR9NjmNd5wAuF6zr26McqAV4c9TMjoUiCu5DvH6lyBQ/oJN86AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_search_hover.png
// module id = 34Es
// module chunks = 9